import { useEffect } from 'react';
import { toast } from 'sonner';
import { guardCubeSession } from '@/services/cube-sso';
import { clearJarvisSession } from '@utils/auth-session';

const CUBE_GUARD_INTERVAL_MS = 5 * 60 * 1000;

const isCubeSession = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  const authData = localStorage.getItem('authData');
  const accessToken = localStorage.getItem('accessToken');
  const mfaEnabled = localStorage.getItem('mfaEnabled');

  if (!authData || !accessToken || mfaEnabled !== 'true') {
    return false;
  }

  try {
    const parsed = JSON.parse(authData);
    return parsed?.authSource === 'cubeforall' || parsed?.source === 'cubeforall' || parsed?.isCCNUser === true;
  } catch {
    return false;
  }
};

export default function CubeSessionGuard() {
  useEffect(() => {
    let cancelled = false;

    const runGuard = async () => {
      if (!isCubeSession()) {
        return;
      }

      try {
        const isSessionAlive = await guardCubeSession();
        if (cancelled || isSessionAlive) {
          return;
        }

        clearJarvisSession();
        toast.warning('Session Expired', { description: 'Your CUBEforall session expired. Please sign in again.' });
        window.location.href = '/auth';
      } catch {
        clearJarvisSession();
        toast.warning('Session Expired', {
          description: 'Unable to verify your CUBEforall session. Please sign in again.',
        });
        window.location.href = '/auth';
      }
    };

    void runGuard();
    const interval = window.setInterval(() => void runGuard(), CUBE_GUARD_INTERVAL_MS);

    return () => {
      cancelled = true;
      window.clearInterval(interval);
    };
  }, []);

  return null;
}
